import BaseOrder from './BaseOrder';

class Ticket extends BaseOrder  {

    constructor(data) {
        super(data);
        this.ticket = this.data.ticketSet[0];
        this.id = this.ticket.id;
        this.orders = this.ticket.orders.filter(o => !!o.event)
                .sort((o1, o2) => new Date(o2.event.startDate).getTime() - new Date(o1.event.startDate).getTime());
        this.latestOrder = this.orders[0];
        const nonPassedOrders = this.orders.filter(o => !this.isEventPassed(o.event));
        this.closestOrder = nonPassedOrders[nonPassedOrders.length - 1];
        this.earliestDate = null;
        if (this.closestOrder) {
            this.earliestDate = this.closestOrder.event.startDate;
        }
        this.latestDate = this.latestOrder.event.startDate;
        this.closestOrderWithMeeting = this.orders.filter(o => this.orderCanStartMeeting(o)).at(-1);
    }

    orderCanStartMeeting(order) {
        return !this.isEventPassed(order.event) &&
            this.isOrderPaid &&
            order.service.meetingType === 'ON' &&
            order.event.roomId &&
            order.event.roomPassword

    }

    get events() {
        return this.orders.map(o => ({
            ...o.event,
            orderId: o.id,
            isTransferEnabled: !this.isTransferAndCancelDisabled(o.event) && this.isOrderPaid,
            canStartMeeting: o.id === this.closestOrderWithMeeting?.id,
            hasPassed: !this.isOrderHistory && this.isEventPassed(o.event)
        }));
    }

    get isTicket() {
        return true;
    }

    get order() {
        return this.latestOrder;
    }

    get visits()  {
        return this.ticket.description.visit;
    }

}

export default Ticket
